<ng-container *transloco="let t">
  <form class="flex h-full max-h-full flex-col">
    <div class="flex flex-1 flex-col gap-4">
      @if (targetingForm().errors(); as errors) {
        @if (errors.length) {
          <div class="text-destructive flex items-center gap-2 text-sm">
            <IIcon name="alertTriangle" />
            @for (error of errors; track error.kind) {
              @if (error.kind === "audienceAlreadyExists") {
                {{ t("sd-targeting-add-popup.already_exists") }}
              }
            }
          </div>
        }
      }
      <div class="flex flex-col gap-1.5">
        <label iLabel>
          {{ t("sd-strategy-creation.targeting_type") }}
        </label>
        <ISelectMenu fitTriggerWidth [formField]="targetingForm.targetingType">
          <ISelectTrigger data-testid="targeting-type">
            <ISelectValue [placeholder]="t('sd-strategy-creation.select_targeting_type')">
              <div *iSelectValue="let value">
                {{ t(value | sdTargetingTypeFormatted) }}
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (option of targetingTypes(); track option.value) {
              <ISelectOption [value]="option.value" [disabled]="option.disabled" [attr.data-testid]="option.testid">
                {{ t(option.label) }}
              </ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>
      </div>

      @if (targetingForm.targetingType().value(); as type) {
        @if (type === TargetingType.PRODUCT) {
          <div class="flex flex-col gap-1.5">
            <label iLabel>{{ t("common.segment") }}</label>
            <div class="flex flex-1 flex-row gap-2">
              <ISelectMenu
                class="w-full"
                fitTriggerWidth
                [formField]="targetingForm.segment"
                [(searchQuery)]="segmentQueryFilter"
              >
                <ISelectTrigger>
                  <ISelectValue>
                    <div *iSelectValue="let value">
                      {{ value.name }}
                    </div>
                  </ISelectValue>
                </ISelectTrigger>
                <ISelectContent>
                  @for (option of filteredSegments(); track option.segmentId) {
                    <ISelectOption [value]="option">
                      {{ option.name }}
                    </ISelectOption>
                  }
                </ISelectContent>
              </ISelectMenu>
              <button iButton variant="ghost" class="shrink-0" (click)="createNewSegment()">
                {{ t("sd-strategy-creation.create_segment") }}
              </button>
            </div>
          </div>
        } @else if (type === TargetingType.REMARKETING) {
          <div class="flex flex-col gap-1.5">
            <label iLabel>{{ t("sd-strategy-creation.event_type") }}</label>
            <ISelectMenu fitTriggerWidth [formField]="targetingForm.audienceExpressionType">
              <ISelectTrigger>
                <ISelectValue>
                  <div *iSelectValue="let value">
                    {{ value | sdEventTypeFormatted }}
                  </div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                @for (option of eventTypes; track option) {
                  <ISelectOption [value]="option">
                    {{ option | sdEventTypeFormatted }}
                  </ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </div>
          <div class="flex flex-col gap-1.5">
            <label iLabel>{{ t("sd-strategy-creation.match_type") }}</label>
            <ISelectMenu fitTriggerWidth [formField]="targetingForm.audienceMatchType">
              <ISelectTrigger>
                <ISelectValue>
                  <div *iSelectValue="let value">
                    {{ value | sdMatchTypeFormatted }}
                  </div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                @for (option of matchTypes(); track option.AudienceMatchType) {
                  <ISelectOption
                    [value]="option.AudienceMatchType"
                    [disabled]="option.disabled"
                    [iTooltip]="option.tooltip"
                    iTooltipPlacement="right-center"
                    iTooltipMaxWidth="200"
                  >
                    {{ option.label }}
                  </ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </div>
          <div class="flex flex-col gap-1.5">
            <label iLabel>{{ t("sd-strategy-creation.lookback") }}</label>
            <ISelectMenu fitTriggerWidth [formField]="targetingForm.audienceLookback">
              <ISelectTrigger>
                <ISelectValue />
              </ISelectTrigger>
              <ISelectContent>
                @for (option of supportedLookback; track option) {
                  <ISelectOption [value]="option">
                    {{ option }}
                  </ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </div>
        }
      }
    </div>
  </form>
</ng-container>
